import { useSite } from '@/context/SiteContext';

const DAYS = [
    { key: 'hours_monday', label: 'Lunedì' },
    { key: 'hours_tuesday', label: 'Martedì' },
    { key: 'hours_wednesday', label: 'Mercoledì' },
    { key: 'hours_thursday', label: 'Giovedì' },
    { key: 'hours_friday', label: 'Venerdì' },
    { key: 'hours_saturday', label: 'Sabato' },
    { key: 'hours_sunday', label: 'Domenica' },
];

/**
 * HoursList — renders the weekly hours from site settings, one line per day.
 * Reused in Footer and Contatti to guarantee single source of truth.
 */
export default function HoursList({ compact = false, className = '' }) {
    const { settings } = useSite();
    return (
        <ul className={`${compact ? 'space-y-1' : 'space-y-1.5'} text-sm ${className}`}>
            {DAYS.map((d) => {
                const val = settings[d.key];
                if (val === undefined) return null;
                const isClosed = String(val).trim().toLowerCase() === 'chiuso';
                return (
                    <li key={d.key} className="flex flex-wrap items-baseline gap-x-3">
                        <span className="font-medium min-w-[6rem]">{d.label}</span>
                        <span className={isClosed ? 'text-muted-foreground italic' : 'text-muted-foreground'}>
                            {val || '—'}
                        </span>
                    </li>
                );
            })}
        </ul>
    );
}
